import MuxVideo from "@components/MuxVideo"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body14Styles } from "@constants/typography"
import React from "react"
import styled from "styled-components"

export const Container = styled.div<{ $caption: boolean }>`
  padding: 0 20px 88px;
  overflow: hidden;

  @media ${breakpoints.tablet} {
    padding: 0 calc(1 / 12 * 100vw) 88px;
  }

  @media ${breakpoints.laptop} {
    padding: 0 calc(1 / 12 * 100vw) 163px;
    ${({ $caption }) => ($caption ? "padding-bottom: 145px;" : "")}
  }
`

export const Content = styled.div`
  position: relative;
  width: 100%;
  height: calc((100vw - 40px) * 0.56);

  @media ${breakpoints.laptop} {
    width: calc(10 / 12 * 100vw);
    height: calc(10 / 12 * 100vw * 0.5625);
  }

  video {
    &:focus {
      outline: none;
    }
  }
`

const CaptionWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  align-items: center;
`

const Caption = styled.div`
  width: calc(100% - 35px);
  font-family: "Avenir Roman";
  font-size: 15px;
  color: ${colors.black};
  line-height: 22px;
  opacity: 0.3;

  @media ${breakpoints.tablet} {
    ${body14Styles}
    color: ${colors.mediumGray};
    opacity: 1;
  }

  @media ${breakpoints.laptop} {
    ${body14Styles}
    color: ${colors.mediumGray};
    opacity: 1;
  }
`

const Dash = styled.div`
  width: 23px;
  height: 1px;
  margin-right: 12px;
  background-color: ${colors.mediumGray};
`

interface MediaMuxProps {
  autoplayVideo?: boolean
  blockId?: string
  caption?: string
  muxMobileVideo: {
    thumbnailTime: string
    title: string
    video: {
      assetId: string
      audioOnly: boolean
      created_at: number
      duration: number
      max_stored_frame_rate: number
      max_stored_resolution: string
      playbackId: string
      ratio: string
      ready: boolean
      version: number
    }
  }
  muxVideo: {
    thumbnailTime: string
    title: string
    video: {
      assetId: string
      audioOnly: boolean
      created_at: number
      duration: number
      max_stored_frame_rate: number
      max_stored_resolution: string
      playbackId: string
      ratio: string
      ready: boolean
      version: number
    }
  }
}

const MediaMux: React.FC<MediaMuxProps> = ({
  autoplayVideo,
  blockId,
  caption,
  muxMobileVideo,
  muxVideo,
}) =>
  muxVideo || muxMobileVideo ? (
    <Container $caption={!!caption} id={blockId || undefined}>
      <Content>
        <MuxVideo
          autoplayVideo={autoplayVideo}
          muxMobileVideo={muxMobileVideo}
          muxVideo={muxVideo}
        />
      </Content>
      {caption && (
        <CaptionWrapper>
          <Dash />
          <Caption>{caption}</Caption>
        </CaptionWrapper>
      )}
    </Container>
  ) : null

export default MediaMux
